
  var _styles = {
  "invite-popup-modal": {
    "width": "10rem",
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center",
    "position": "relative"
  },
  "invite-popup-card": {
    "borderRadius": "0.48rem",
    "position": "relative",
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center"
  },
  "invite-popup-call-icon-container": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "invite-popup-call-icon": {
    "width": "0.29333rem",
    "height": "0.4rem",
    "marginRight": "0.08rem"
  },
  "invite-popup-call-label": {
    "color": "rgb(85,85,85)",
    "fontSize": "0.32rem"
  },
  "invite-popup-reward-amount": {
    "color": "rgb(17,17,17)",
    "fontSize": "1.81333rem",
    "fontWeight": "700",
    "lineHeight": "2rem",
    "textAlign": "center"
  },
  "invite-popup-description": {
    "fontWeight": "400",
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.37333rem"
  },
  "invite-popup-win-label-text": {
    "color": "rgb(255,255,255)",
    "fontSize": "0.26667rem"
  },
  "invite-popup-join-btn-text": {
    "color": "rgb(0,0,0)",
    "fontSize": "0.48rem",
    "fontWeight": "500"
  },
  "invite-popup-win-label": {
    "position": "absolute",
    "right": 0,
    "paddingTop": 0,
    "paddingRight": "0.17333rem",
    "paddingBottom": 0,
    "paddingLeft": "0.17333rem",
    "top": "-0.26667rem",
    "height": "0.50667rem",
    "backgroundColor": "rgb(255,45,25)",
    "borderRadius": "0.66667rem 0.66667rem 0.66667rem 0.2rem",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "overflow": "visible",
    "zIndex": 1
  },
  "invite-popup-create-btn": {
    "width": "6.70667rem",
    "height": "1.2rem",
    "borderRadius": "0.6rem",
    "borderWidth": "2px",
    "borderStyle": "solid",
    "borderColor": "rgb(255,255,255)",
    "marginTop": "0.26667rem",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "invite-popup-create-btn-text": {
    "color": "rgb(255,255,255)",
    "fontSize": "0.48rem",
    "fontWeight": "500"
  },
  "invite-popup-close-btn": {
    "marginTop": "1.4rem"
  },
  "invite-popup-head-image": {
    "margin": "auto"
  },
  "invite-popup-card-bg-image": {
    "width": "7.54667rem",
    "height": "8.25333rem",
    "margin": "auto"
  }
};



  module.exports = _styles;
  